import React from "react";
import {
  FormControlLabel,
  Typography,
  Button,
  Checkbox,
  FormGroup,
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
function ViewResult() {
  return (
    <>
      <Typography  align="center">
      - 코리아크레딧뷰로(주)의 개인정보 이용 및 제공동의 -

㈜코리아크레딧뷰로(이하 “회사”라고 한다)가 제공하는 “본인확인서비스” 의 휴대폰 본인확인과 관련하여 본인으로부터 취득한 개인정보는 "정보통신망이용촉진 및 정보보호등에 관한 법률" 및 
"신용정보의 이용 및 보호에 관한 법률"에 따라 본인의 동의를 얻어 다음의 목적을 위해 제공 및 이용 됩니다.

[개인정보 이용 및 제공 목적]

“회사”는 생년월일과 휴대폰번호 일치 여부 및 휴대폰 점유 확인과 휴대폰 번호보호 서비스를 
안내하기 위한 목적으로 아래의 회사에 다음의 정보를 이용 및 제공합니다.
  
① 이용 및 제공 정보 
    - 휴대폰번호, 통신사정보, 생년월일, 성명, 성별, 내외국인 정보
      
② 제공사
    - SKT, KT, LG U+, 드림시큐리티, KCT, 스탠다드네트웍스, 인포뱅크, 씽크풀, 민앤지 및 
본인확인 서비스 요청 사업자

[개인정보 정보 보유 및 이용기간]

이용자의 개인정보는 원칙적으로 개인정보의 제공 목적이 달성되면 지체 없이 파기합니다. 단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존합니다.
    
① 관련법령에 의한 정보보유 사유 
정보통신망 이용촉진 및 정보보호 등에 관한 법률과 신용정보의 이용 및 보호에 관한 법률 등 관계법령의 규정에 의하여 보존할 필요가 있는 경우 회사는 관계법령에서 정한 일정한 기간 동안 회원정보를 보관합니다. 이 경우 회사는 보관하는 정보를 그 보관의 목적으로만 이용하며 보존기간은 아래와 같습니다.

1. 정보통신망 이용촉진 및 정보보호 등에 관한 법률과 신용정보의 이용 및 보호의 관한 법률에 의거 정보 보존 기간: 3년

2. 회사 내부 방침에 의하여 부정이용방지를 위한 정보 보존기간: 5년
	 
※ 본 개인정보 수집 이용동의는 거부할 수 있으나, 거부 시에는 휴대폰본인확인서비스를 제공받으실 수 없습니다. 


      </Typography>
      <hr />
    </>
  );
}
function JeonMoon1(props) {
  const classes = props.useStyles();
  const [showResults, setShowResults] = React.useState(false);
  const onView = (e) => {
    e.preventDefault();
    setShowResults(!showResults);
  };
  return (
    <>
      <FormGroup row>
        <FormControlLabel
          control={
            <Checkbox
              disabled={props.SelfCertification}
              checked={props.JeonMoon1}
              onChange={(e) => {
                props.onChangeJeonMoon1Yn(e.target.checked);
              }}
              name="Marketing"
            />
          }
          label={
            <Typography className={classes.TypographyFont}>
              [필수]개인정보 이용약관 동의
            </Typography>
          }
        />
        <Button
          className={classes.Button}
          variant="text"
          color="primary"
          type="submit"
          onClick={onView}
          startIcon={<VisibilityIcon />}
        >
          내용보기
        </Button>
      </FormGroup>

      <hr />
      {showResults ? <ViewResult /> : null}
    </>
  );
}
export default JeonMoon1;
